import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useCurrentUser } from './useCurrentUser';
import UserService, { CHAVES_USUARIO } from '../api/UserService';
import { getApiErrorMessage } from '../utils/http';

/**
 * Aceite dos Termos de Serviço de quem já tinha conta — quem se cadastra hoje aceita no
 * próprio cadastro (checkbox em /register). Mesma chave de Configurações: o portão não
 * custa uma requisição a mais.
 */
export default function useTerms() {
  const { userId } = useCurrentUser();
  const [aceito, setAceito] = useState<boolean>(false);
  const [salvando, setSalvando] = useState<boolean>(false);
  const [erro, setErro] = useState<string>('');

  const query = useQuery({
    queryKey: CHAVES_USUARIO.porId(userId!),
    queryFn: async () => (await UserService.getUserById(userId!)).data,
    enabled: Boolean(userId),
  });

  const aceitar = async () => {
    setSalvando(true);
    setErro('');
    try {
      await UserService.acceptTerms();
      // Só fecha depois que o servidor confirmou: aceite otimista é aceite que não existe.
      setAceito(true);
    } catch (err: unknown) {
      setErro(getApiErrorMessage(err, 'Não foi possível registrar seu aceite. Tente novamente.'));
    } finally {
      setSalvando(false);
    }
  };

  return {
    // `isSuccess`: falha de rede não tranca o app atrás do portão.
    precisaAceitar: query.isSuccess && !query.data?.termsAcceptedAt && !aceito,
    aceitar,
    salvando,
    erro,
  };
}
